import { cn as e } from "../shared/utils.js";
import { mergeProps as t } from "@base-ui/react/merge-props";
import { useRender as n } from "@base-ui/react/use-render";
import { forwardRef as r } from "react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import { cva as o } from "class-variance-authority";
//#region src/badge/badge.tsx
var s = o("inline-flex w-fit shrink-0 items-center relative justify-center rounded-full border border-transparent align-middle font-normal whitespace-nowrap [&_svg]:shrink-0 [&_svg]:block", {
	defaultVariants: {
		size: "md",
		color: "lightGray",
		shape: "pill"
	},
	variants: {
		size: {
			sm: "min-h-4 px-1 gap-1 text-sm/3 [&_svg]:size-3",
			md: "min-h-6 px-1.5 py-0.5 gap-1.5 text-sm [&_svg]:size-4",
			lg: "min-h-7 px-2.5 py-0.5 gap-1.5 text-base [&_svg]:size-4",
			xl: "min-h-8 px-3 py-1 gap-1.5 text-base [&_svg]:size-4"
		},
		color: {
			outlinedGray: "bg-bg-primary border-border-100 text-text-primary [&_svg]:text-icon-primary",
			lightGray: "bg-bg-secondary text-text-secondary [&_svg]:text-icon-primary",
			darkGray: "bg-bg-tertiary text-text-primary [&_svg]:text-icon-primary",
			white: "bg-bg-primary text-text-primary [&_svg]:text-icon-primary",
			green: "bg-palette-success-palette-green-bg text-palette-success-palette-green-textandicon [&_svg]:text-palette-success-palette-green-textandicon",
			yellow: "bg-palette-warning-palette-yellow-bg text-palette-warning-palette-yellow-textandicon [&_svg]:text-palette-warning-palette-yellow-textandicon",
			red: "bg-palette-error-palette-red-bg text-palette-error-palette-red-textandicon [&_svg]:text-palette-error-palette-red-textandicon",
			blue: "bg-palette-blue-bg text-palette-blue-textandicon [&_svg]:text-palette-blue-textandicon"
		},
		shape: {
			pill: "rounded-full",
			rounded: "rounded-md"
		}
	}
}), c = r(({ className: r, color: i, render: a, size: o, shape: c, ...l }, u) => {
	let d = { className: e(s({
		className: r,
		color: i,
		size: o,
		shape: c
	})) };
	return n({
		defaultTagName: "span",
		props: t(d, l),
		ref: u,
		render: a
	});
});
c.displayName = "Badge";
function l() {
	return /* @__PURE__ */ a("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": "true",
		focusable: "false",
		children: [/* @__PURE__ */ i("path", {
			d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
			fill: "var(--color-bg-primary)"
		}), /* @__PURE__ */ i("path", {
			d: "M15.2929 7.29312C15.6834 6.9026 16.3164 6.9026 16.7069 7.29312C17.0974 7.68363 17.0974 8.31662 16.7069 8.70713L13.414 12L16.7069 15.2929L16.7759 15.3684C17.0963 15.7611 17.073 16.3408 16.7069 16.7069C16.3408 17.073 15.7611 17.0963 15.3684 16.7759L15.2929 16.7069L12 13.414L8.70713 16.7069C8.31662 17.0974 7.68363 17.0974 7.29312 16.7069C6.9026 16.3164 6.9026 15.6834 7.29312 15.2929L10.586 12L7.29312 8.70713L7.22411 8.63162C6.90371 8.23885 6.92699 7.65924 7.29312 7.29312C7.65924 6.92699 8.23885 6.90371 8.63162 7.22411L8.70713 7.29312L12 10.586L15.2929 7.29312Z",
			fill: "currentColor"
		})]
	});
}
var u = r(({ className: t, ...n }, r) => /* @__PURE__ */ i("button", {
	...n,
	ref: r,
	type: "button",
	className: e("focus-visible:focus-ring-primary inline-flex shrink-0 cursor-pointer items-center justify-center rounded-full outline-none disabled:cursor-not-allowed", t),
	children: /* @__PURE__ */ i(l, {})
}));
u.displayName = "Badge.Close";
var d = Object.assign(c, { Close: u });
//#endregion
export { d as Badge };
